import {TimeslotProps} from 'src/types/types'
// eslint-disable-next-line no-restricted-imports -- TimeslotsSelector not yet ported to components-new
import TimeslotsSelector from 'src/components/elements/TimeslotsSelector/TimeslotsSelector'
import {useState, useEffect} from 'react'
import AppDialog from 'src/components-new/feedback/AppDialog'
import Button from 'src/components-new/primitives/Button'

type TimeslotsDialogProps = {
  title: string;
  onClose: () => void;
  timeslots?: TimeslotProps[];
  onEdit: (value: TimeslotProps[]) => void;
};

const TimeslotsDetailDialog: React.FC<TimeslotsDialogProps> = ({title, timeslots = [], onClose, onEdit}) => {
  const [values, setValues] = useState<TimeslotProps[]>(timeslots)
  const [isModified, setIsModified] = useState<boolean>(false)
  const [isValid, setIsValid] = useState<boolean>(true)

  useEffect(() => {
    setIsModified(JSON.stringify(timeslots) !== JSON.stringify(values))
  }, [timeslots, values])

  useEffect(() => {
    const checkValidity = () => {
      return values.every((timeslot) => timeslot.day && timeslot.from && timeslot.to)
    }
    setIsValid(checkValidity())
  }, [values])

  const handleSave = () => {
    if (isValid) {
      onEdit(values)
      onClose()
    }
  }

  return (
    <AppDialog
      actions={
        <>
          <Button variant="primary" disabled={!isModified || !isValid} onClick={handleSave}>
            {'Salva'}
          </Button>
          <Button variant="secondary" onClick={onClose}>
            {'Annulla'}
          </Button>
        </>
      }
      maxWidth="md"
      onClose={onClose}
      open
      title={title}
    >
      <TimeslotsSelector onChange={setValues} value={values} />
    </AppDialog>
  )
}

export default TimeslotsDetailDialog
